import request from '@/router/axios';

const getList = (current, size, params) => request({
  url: '/api/mcc-base/project/base/info/page',
  method: 'get',
  params: {
    ...params,
    current,
    size,
  },
})
const getDeveloperprojectList = (current, size, params) => request({
  url: '/api/mcc-staff/developerproject/list',
  method: 'get',
  params: {
    ...params,
    current,
    size,
  },
})
// 根据角色获取project
const getList1 = (current, size, params) => request({
  url: '/api/mcc-base/project/base/info/page1',
  method: 'get',
  params: {
    ...params,
    current,
    size,
  },
})

const add = params => request({
  url: '/api/mcc-base/project/base/info/add',
  method: 'post',
  data: params,
})

const detail = params => request({
  url: '/api/mcc-base/project/base/info/detail',
  method: 'get',
  params: {
    ...params,
  },
})

const edit = params => request({
  url: '/api/mcc-base/project/base/info/update',
  method: 'post',
  data: params,
})

const remove = ids => request({
  url: '/api/mcc-base/project/base/info/remove',
  method: 'post',
  params: {
    ids,
  },
})

const updateProjectRole = params => request({
  url: '/api/mcc-base/project/base/info/updateProjectRole',
  method: 'post',
  data: {
    ...params,
  },
})

export default {
  getList,
  getList1,
  add,
  detail,
  edit,
  remove,
  getDeveloperprojectList,
  updateProjectRole,
};
